export function formatApprovalError(error: unknown, fallbackMessage: string): string {
  if (!error) return fallbackMessage

  const raw = error instanceof Error ? error.message : String(error)
  const message = raw.toLowerCase()

  if (
    message.includes('rejected') ||
    message.includes('denied') ||
    message.includes('cancelled') ||
    message.includes('canceled') ||
    message.includes('wallet timeout') ||
    message.includes('timeout')
  ) {
    return 'Transaction cancelled.'
  }

  if (message.includes('unknown rpc error')) {
    return fallbackMessage
  }

  return raw
}
